
import axios from 'axios';

// Prefer explicit env base URL; otherwise fall back to the same host the app is served from
// (useful when accessing from another device on the network). Defaults to port 5000 if not specified.
const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.hostname}:5000`
    : 'http://localhost:5000');

let csrfCache = null;

const apiClient = axios.create({
  baseURL,
  withCredentials: true,
});

const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  return document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(c => c.startsWith(`${name}=`))
    .map(c => decodeURIComponent(c.split('=')[1]))[0] || null;
};

// Attach session-scoped bearer token when present (fallback for browsers blocking third-party cookies)
apiClient.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined' ? sessionStorage.getItem('authToken') : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const csrf = getCookie('csrf_token') || csrfCache;
  if (csrf) {
    config.headers['x-csrf-token'] = csrf;
  }
  return config;
});

// Capture fresh CSRF token from any response header (helps when cookie is not readable on this domain)
apiClient.interceptors.response.use(
  (response) => {
    const headerToken = response.headers['x-csrf-token'];
    if (headerToken) {
      csrfCache = headerToken;
    }
    return response;
  },
  (error) => {
    const headerToken = error?.response?.headers?.['x-csrf-token'];
    if (headerToken) {
      csrfCache = headerToken;
    }
    return Promise.reject(error);
  }
);

export default apiClient;
